// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  endpoint: 'https://graphql.undiknas.ac.id',
  firebase: {
    apiKey: 'AIzaSyA4gnt6oCnQWMuDy5liOXIyI0kj0ljOaQc',
    authDomain: 'undiknas-core.firebaseapp.com',
    databaseURL: 'https://undiknas-core.firebaseio.com',
    projectId: 'undiknas-core',
    storageBucket: 'undiknas-core',
    messagingSenderId: '806874187364',
    clientId:
      '900061952150-01jsser7in23mh8v8bdr1c8b4c9eo0vf.apps.googleusercontent.com',
    appId: '1:806874187364:web:288ba504e6927647e04171',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
